<template>
    <section
        class="flex flex-col flex-grow lg:ml-[224px] lg:mr-0 bg-main-bg-500 dark:bg-main-bg-dark-500 transition-spacing duration-300 ease-in-out"
        :class="[
            menuState === 'opened' ? 'ml-[224px] mr-[-224px]' : 'ml-0 mr-0',
        ]"
    >
        <slot></slot>
    </section>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
    name: 'TheContent',
    setup() {
        const store = useStore()

        const menuState = computed(() => store.getters['ui/menuState'])

        return {
            menuState,
        }
    },
})
</script>
